import React, {
  ReactElement,
  Dispatch,
  SetStateAction,
  CSSProperties,
} from 'react';

import COLORS from '~/constants/colors';
import { FONT_SIZES } from '~/constants/typography';
import Slider from '~/components/inputs/Slider';

import { Session } from '../../../models';

interface SongIntervalSliderProps {
  session: Session;
  setSession: Dispatch<SetStateAction<Session>>;
  style?: CSSProperties;
}

function SongIntervalSlider({
  session,
  setSession,
  style,
}: SongIntervalSliderProps): ReactElement {
  const playerStartTime = session.videoStartTime / 1000;
  const playerEndTime = session.videoEndTime / 1000;
  const handleChange = (values) =>
    setSession({
      ...session,
      ...(values[0] !== playerStartTime && {
        videoStartTime: values[0] * 1000,
      }),
      ...(values[1] !== playerEndTime && { videoEndTime: values[1] * 1000 }),
    });
  const getMark = (label) => ({
    style: {
      maxWidth: 'min(3em, 15vw)',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      color: COLORS.tundora,
      fontSize: FONT_SIZES.text,
      whiteSpace: 'nowrap' as const,
    },
    label,
  });
  const getActiveMark = (label) => ({
    style: {
      ...getMark(label).style,
      color: COLORS.dodgerBlue,
    },
    label,
  });
  const marks = {
    0: getMark(0),
    [session.duration]: getMark(session.duration),
    [playerStartTime]: getActiveMark(playerStartTime),
    [playerEndTime]: getActiveMark(playerEndTime),
  };

  // Styling
  const songIntervalSliderStyle = {
    width: 'min(20em, 60vw)',
    height: '2em',
    ...style,
  };
  const handleStyle = {
    width: '1.25em',
    height: '1.25em',
    marginTop: '-0.5em',
    backgroundColor: COLORS.dodgerBlue,
    borderColor: COLORS.linkWater,
    opacity: 1,
    boxShadow: 'none',
  };

  return (
    <Slider
      range
      pushable
      min={0}
      max={session.duration}
      step={1}
      marks={marks}
      value={[playerStartTime, playerEndTime]}
      onChange={handleChange}
      handleStyle={handleStyle}
      style={songIntervalSliderStyle}
    />
  );
}

export default SongIntervalSlider;
